import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import InstagramIcon from "components/Redesign/InstagramIcon.js";

const INSTAGRAM_URL = "https://www.instagram.com/honig_traum?igsh=ZHVhcDJzZ3Y4Ynlr&utm_source=qr";

function SiteFooter() {
  const { t } = useTranslation();
  return (
    <footer className="rd-footer">
      <div className="wrap">
        <div className="footer-grid">
          <div>
            <div className="footer-logo-name">
              IBM Honig <span className="footer-logo-suffix">· Imkerei Bühler</span>
            </div>
            <span className="footer-logo-sub">Est. 2007 · Schweiz</span>
            <p className="footer-brand-desc">{t("footer.Brand description")}</p>
          </div>
          <div className="footer-col">
            <h4>{t("footer.Navigation")}</h4>
            <Link to="/">{t("nav.Home")}</Link>
            <Link to="/unser-honig">{t("nav.Our honey")}</Link>
            <Link to="/fuer-unternehmen">{t("nav.For businesses")}</Link>
            <Link to="/ueber-uns">{t("nav.About us")}</Link>
            <Link to="/ueber-uns/unsere-geschichte">{t("nav.Our story")}</Link>
            <Link to="/ueber-uns/unsere-standorte">{t("nav.Our locations")}</Link>
            <Link to="/live">{t("nav.Live from the hive")}</Link>
            <Link to="/faq">{t("nav.FAQ")}</Link>
          </div>
          <div className="footer-col">
            <h4>{t("footer.Honey")}</h4>
            <Link to="/unser-honig">Frühlingsblüte</Link>
            <Link to="/unser-honig">Wald</Link>
            <Link to="/unser-honig">Primavera</Link>
            <Link to="/unser-honig">Estate</Link>
            <Link to="/unser-honig">Alpenwiese</Link>
          </div>
          <div className="footer-col">
            <h4>{t("footer.Contact")}</h4>
            <a href="https://www.ibm-honig.ch">ibm-honig.ch</a>
            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="footer-social-link">
              <InstagramIcon size={16} /> Instagram
            </a>
          </div>
        </div>
        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Imkerei Bühler · ibm-honig.ch</p>
          <p className="footer-legal">
            <Link to="/impressum">Impressum</Link>
            <span aria-hidden="true"> · </span>
            <Link to="/datenschutz">Datenschutz</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default SiteFooter;
